export default "__VITE_ASSET__Dp$jpNrd__"